<div class="student-edit-details-module">
    <div class="register-confirmation-page-wrap">
        <div class="session-form-hold">
            <div class="pt-8 pb-16">
                <h2 class="mb-1">
                    <strong>Edit Your Details</strong>
                </h2>
            </div>
            <form [formGroup]="studentUpdateForm" (ngSubmit)="onSubmit()">
                <div
                    class="mb-1 qtac-error-container"
                    data-test="error-message-register-main"
                    *ngIf="showRegisterProfileInvalid"
                >
                    {{ studentUpdateErrorMessage }}
                </div>
                <div class="mb-1">
                    <div>First Name *</div>
                    <input
                        class="qtac-input"
                        data-test="register-input-firstName"
                        name="firstName"
                        formControlName="firstName"
                        value=""
                    />
                    <div
                            class="help-text"
                            *ngIf="!matchedToQCAAStudent"
                    >
                        First Name must match your <strong>Given Names</strong> field in the My details section of the QCAA Student Portal
                    </div>
                    <ng-container
                        *ngFor="let error of error_messages.firstName"
                    >
                        <small
                            data-test="error-first-name"
                            *ngIf="formControls.firstName.hasError(error.type)"
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>
                <div class="mb-1">
                    <div>Last Name *</div>
                    <input
                        class="qtac-input"
                        data-test="register-input-lastName"
                        name="lastName"
                        formControlName="lastName"
                        value=""
                    />
                    <div
                            class="help-text"
                            *ngIf="!matchedToQCAAStudent"
                    >
                        Last Name must match your <strong>Family Name</strong> field in the My details section of the QCAA Student Portal
                    </div>
                    <ng-container *ngFor="let error of error_messages.lastName">
                        <small
                            data-test="error-last-name"
                            *ngIf="formControls.lastName.hasError(error.type)"
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <div class="mb-1">
                    <div>Date of Birth *</div>
                    <div fxLayout="row">
                        <input
                            matInput
                            class="qtac-input"
                            data-test="register-input-dob"
                            name="dob"
                            formControlName="dob"
                            value=""
                            [matDatepicker]="dob"
                            [max]="maxDate"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="dob"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #dob></mat-datepicker>
                    </div>
                    <ng-container *ngFor="let error of error_messages.dob">
                        <small
                            data-test="error-dob"
                            *ngIf="formControls.dob.hasError(error.type)"
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <div class="mb-1">
                    <div>Mobile Phone</div>
                    <div fxLayout="row">
                        <span class="mobile-prefix">+61</span>
                        <input
                            type="phone"
                            class="qtac-input"
                            data-test="register-input-phone"
                            name="phone"
                            formControlName="phone"
                            (change)="updateNumber()"
                        />
                    </div>
                    <ng-container *ngFor="let error of error_messages.phone">
                        <small
                            data-test="error-phone"
                            *ngIf="formControls.phone.hasError(error.type)"
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <div class="mb-1">
                    <div>LUI *</div>
                    <input
                        type="text"
                        minlength="10"
                        maxlength="10"
                        pattern="\d*"
                        class="qtac-input"
                        data-test="register-input-lui"
                        name="lui"
                        formControlName="lui"
                        value=""
                    />
                    <ng-container *ngFor="let error of error_messages.lui">
                        <small
                            data-test="error-phone"
                            *ngIf="formControls.lui.hasError(error.type)"
                            class="form-error-msg error-msg"
                        >
                            {{ error.message }}
                        </small>
                    </ng-container>
                </div>

                <div class="row">
                    <button
                        data-test="student-cancel-submit"
                        mat-raised-button
                        class="register-confirmation-button mb-1 col"
                        (click)="onNoClick()"
                        type="button"
                    >
                        Cancel
                    </button>
                    <button
                        data-test="student-update-submit"
                        mat-raised-button
                        class="register-confirmation-button mb-1 col"
                        [disabled]="studentUpdateForm.invalid"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
